import { useState, useEffect } from 'react';
import { axiosGetInterviewPanel } from '../stateManagement/api';
import { IInterviewersPanel } from '../models/candidatePipeline.model';

const useInterviewPanel = (requisitionId: string) => {
  const [interviewPanelDetails, setInterviewPanelDetails] =
    useState<IInterviewersPanel>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const response = await axiosGetInterviewPanel(requisitionId);
        setInterviewPanelDetails(response?.interviewPanel);
        setError(null);
      } catch (apiError: any) {
        setError(apiError.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [requisitionId]);

  return { interviewPanelDetails, loading, error };
};

export default useInterviewPanel;
